/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEarningsChartRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {GetEarningsChartResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const getEarningsChart = (request: GetEarningsChartRequest, options?: CashRequestOptions) => post<GetEarningsChartRequest, GetEarningsChartResponse>("/2.0/cash/get-earnings-chart", request, {...options, rejectOnError: true })